// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Trading Commission */
.commission-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

.commission-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.15rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: #fff;
  color: var(--text-muted);
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.commission-tab:hover {
  border-color: #99f6e4;
  color: #0f766e;
  background: #f0fdfa;
}

.commission-tab--active {
  border-color: #0f766e;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.25);
}

.commission-tab--active:hover {
  color: #fff;
  background: linear-gradient(135deg, #0d6b64 0%, #12a89e 100%);
}

.commission-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.commission-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.commission-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.commission-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.commission-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.commission-section__stats {
  display: flex;
  gap: 1.25rem;
}

.commission-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.commission-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

.commission-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.commission-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.commission-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 320px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.commission-search-input::placeholder {
  color: var(--text-muted);
}

.commission-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.commission-table-wrap {
  overflow-x: auto;
}

.commission-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.commission-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.commission-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.commission-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.commission-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.commission-table tbody tr:hover {
  background: #f0fdfa !important;
}

.commission-table tbody tr:last-child td {
  border-bottom: none;
}

.commission-mono {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.commission-currency {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 28px;
}

.commission-currency__icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.commission-currency__icon--placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #64748b;
  font-size: 0.75rem;
}

.commission-currency__name {
  font-weight: 700;
  color: var(--text);
}

.commission-chain {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
}

.commission-table--withdrawal {
  min-width: 52rem;
}

.commission-table--p2p {
  min-width: 48rem;
}

.commission-table--futures {
  min-width: 70rem;
}

.commission-user-cell {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.commission-user-cell strong {
  font-size: 0.82rem;
  color: var(--text);
}

.commission-user-cell span {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.commission-fee-type {
  display: inline-block;
  padding: 0.3rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 600;
}

.commission-fee-type--maker {
  background: #e0f2fe;
  color: #0369a1;
}

.commission-fee-type--taker {
  background: #fef3c7;
  color: #92400e;
}

.commission-fee-type--admin {
  background: #ede9fe;
  color: #5b21b6;
}

.commission-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s, background 0.2s;
}

.commission-btn--view {
  background: #e0f2fe;
  color: #0369a1;
}

.commission-btn--view:hover {
  background: #0ea5e9;
  color: #fff;
}

.commission-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}

/* Order details modal — premium */
.commission-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  animation: commission-modal-fade-in 0.22s ease-out;
}

@keyframes commission-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.commission-modal {
  background: #fff;
  border-radius: 16px;
  max-width: 480px;
  width: 100%;
  box-shadow:
    0 0 0 1px rgba(15, 118, 110, 0.08),
    0 25px 50px -12px rgba(15, 23, 42, 0.28),
    0 12px 24px -8px rgba(15, 23, 42, 0.12);
  overflow: hidden;
  animation: commission-modal-rise 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes commission-modal-rise {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .commission-modal-overlay,
  .commission-modal {
    animation: none;
  }
}

.commission-modal--premium {
  max-width: 520px;
}

.commission-modal__hero {
  position: relative;
  padding: 1.75rem 1.5rem 1.5rem;
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.12) 0%, transparent 42%),
    linear-gradient(135deg, #0d4f4a 0%, #0f766e 38%, #14b8a6 100%);
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.commission-modal__hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 80% 60% at 100% 0%, rgba(255, 255, 255, 0.15), transparent 55%);
  pointer-events: none;
}

.commission-modal__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s, transform 0.15s;
}

.commission-modal__close:hover {
  background: rgba(255, 255, 255, 0.22);
  transform: scale(1.04);
}

.commission-modal__eyebrow {
  margin: 0 0 0.65rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  position: relative;
  z-index: 1;
}

.commission-modal__eyebrow i {
  font-size: 0.85rem;
  opacity: 0.9;
}

.commission-modal__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.2;
  position: relative;
  z-index: 1;
}

.commission-modal__id {
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
  font-size: 1.05rem;
  font-weight: 700;
  word-break: break-all;
}

.commission-modal__meta {
  margin: 0.85rem 0 0;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.78);
  display: flex;
  align-items: center;
  gap: 0.4rem;
  position: relative;
  z-index: 1;
}

.commission-modal__body--premium {
  padding: 0;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.commission-modal__section {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
}

.commission-modal__section:last-of-type {
  border-bottom: none;
}

.commission-modal__section--status {
  background: rgba(255, 255, 255, 0.55);
}

.commission-modal__section-title {
  margin: 0 0 1rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.commission-modal__section-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, #e0f2fe 0%, #ccfbf1 100%);
  color: #0f766e;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
}

.commission-modal__pair-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.commission-modal__pair-card {
  padding: 1rem 1rem;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.commission-modal__pair-label {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 0.35rem;
}

.commission-modal__pair-value {
  font-size: 1.1rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.commission-modal__exec-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem;
}

.commission-modal__stat {
  padding: 0.85rem 1rem;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.commission-modal__stat--span2 {
  grid-column: span 2;
}

.commission-modal__stat-label {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 0.4rem;
}

.commission-modal__stat-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
}

.commission-modal__stat-value--num {
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
  font-size: 1rem;
  font-weight: 600;
  color: #134e4a;
}

.commission-modal__status-banner {
  display: flex;
  justify-content: flex-start;
}

.commission-order-status {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.1rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 1px solid #cbd5e1;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  color: #334155;
}

.commission-order-status i {
  font-size: 0.95rem;
}

.commission-order-status--filled,
.commission-order-status--completed,
.commission-order-status--success {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  color: #047857;
  border-color: rgba(16, 185, 129, 0.35);
}

.commission-order-status--cancelled,
.commission-order-status--canceled,
.commission-order-status--rejected {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #b91c1c;
  border-color: rgba(248, 113, 113, 0.4);
}

.commission-order-status--pending,
.commission-order-status--open,
.commission-order-status--partial {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  color: #b45309;
  border-color: rgba(251, 191, 36, 0.45);
}

.commission-order-status--unknown {
  background: #f1f5f9;
  color: #475569;
  border-color: #e2e8f0;
}

.commission-modal__footer {
  padding: 1rem 1.5rem 1.35rem;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.commission-modal__btn-done {
  padding: 0.65rem 1.75rem;
  font-size: 0.9rem;
  font-weight: 700;
  font-family: inherit;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.35);
  transition: transform 0.15s, box-shadow 0.2s;
}

.commission-modal__btn-done:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(15, 118, 110, 0.42);
}

.commission-modal__btn-done:active {
  transform: translateY(0);
}

@media (max-width: 420px) {
  .commission-modal__pair-grid {
    grid-template-columns: 1fr;
  }

  .commission-modal__exec-grid {
    grid-template-columns: 1fr;
  }

  .commission-modal__stat--span2 {
    grid-column: span 1;
  }
}

.commission-side {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.commission-side--lg {
  padding: 0.4rem 0.85rem;
  border-radius: 8px;
  font-size: 0.8rem;
  letter-spacing: 0.04em;
}

.commission-side--buy {
  background: #dcfce7;
  color: #166534;
}

.commission-side--sell {
  background: #fef2f2;
  color: #b91c1c;
}

.commission-side--neutral {
  background: #f1f5f9;
  color: #475569;
}

.commission-status {
  font-weight: 600;
  color: #166534;
}

.commission-table__loading {
  text-align: center;
  padding: 2rem 1rem !important;
  color: var(--text-muted);
}

.commission-empty--error {
  margin: 0 1.5rem 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.commission-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
  font-size: 0.875rem;
  color: var(--text-muted);
}

.commission-page-btn {
  padding: 0.45rem 1rem;
  font-size: 0.85rem;
  font-family: inherit;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text);
  cursor: pointer;
}

.commission-page-btn:hover:not(:disabled) {
  border-color: #0f766e;
  color: #0f766e;
}

.commission-page-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/TradingCommissionPage.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX;;;2CAGyC;EACzC,gBAAgB;EAChB,qEAAqE;AACvE;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B;;kEAEgE;EAChE,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,6DAA6D;EAC7D,cAAc;EACd,sCAAsC;AACxC;;AAEA;;;EAGE,6DAA6D;EAC7D,cAAc;EACd,sCAAsC;AACxC;;AAEA;;;EAGE,6DAA6D;EAC7D,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,6DAA6D;EAC7D,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Trading Commission */\n.commission-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n}\n\n.commission-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem 1.15rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: #fff;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s, color 0.2s;\n}\n\n.commission-tab:hover {\n  border-color: #99f6e4;\n  color: #0f766e;\n  background: #f0fdfa;\n}\n\n.commission-tab--active {\n  border-color: #0f766e;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.25);\n}\n\n.commission-tab--active:hover {\n  color: #fff;\n  background: linear-gradient(135deg, #0d6b64 0%, #12a89e 100%);\n}\n\n.commission-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.commission-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.commission-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.commission-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.commission-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.commission-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.commission-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.commission-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n.commission-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.75rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.commission-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.commission-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 320px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.commission-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.commission-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.commission-table-wrap {\n  overflow-x: auto;\n}\n\n.commission-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.commission-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.commission-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.commission-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.commission-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.commission-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.commission-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.commission-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.commission-currency {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  min-height: 28px;\n}\n\n.commission-currency__icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.commission-currency__icon--placeholder {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  color: #64748b;\n  font-size: 0.75rem;\n}\n\n.commission-currency__name {\n  font-weight: 700;\n  color: var(--text);\n}\n\n.commission-chain {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.commission-table--withdrawal {\n  min-width: 52rem;\n}\n\n.commission-table--p2p {\n  min-width: 48rem;\n}\n\n.commission-table--futures {\n  min-width: 70rem;\n}\n\n.commission-user-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.commission-user-cell strong {\n  font-size: 0.82rem;\n  color: var(--text);\n}\n\n.commission-user-cell span {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.commission-fee-type {\n  display: inline-block;\n  padding: 0.3rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n.commission-fee-type--maker {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.commission-fee-type--taker {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.commission-fee-type--admin {\n  background: #ede9fe;\n  color: #5b21b6;\n}\n\n.commission-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s, background 0.2s;\n}\n\n.commission-btn--view {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.commission-btn--view:hover {\n  background: #0ea5e9;\n  color: #fff;\n}\n\n.commission-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Order details modal — premium */\n.commission-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  animation: commission-modal-fade-in 0.22s ease-out;\n}\n\n@keyframes commission-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.commission-modal {\n  background: #fff;\n  border-radius: 16px;\n  max-width: 480px;\n  width: 100%;\n  box-shadow:\n    0 0 0 1px rgba(15, 118, 110, 0.08),\n    0 25px 50px -12px rgba(15, 23, 42, 0.28),\n    0 12px 24px -8px rgba(15, 23, 42, 0.12);\n  overflow: hidden;\n  animation: commission-modal-rise 0.28s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes commission-modal-rise {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .commission-modal-overlay,\n  .commission-modal {\n    animation: none;\n  }\n}\n\n.commission-modal--premium {\n  max-width: 520px;\n}\n\n.commission-modal__hero {\n  position: relative;\n  padding: 1.75rem 1.5rem 1.5rem;\n  background:\n    linear-gradient(145deg, rgba(255, 255, 255, 0.12) 0%, transparent 42%),\n    linear-gradient(135deg, #0d4f4a 0%, #0f766e 38%, #14b8a6 100%);\n  color: #fff;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.commission-modal__hero::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(ellipse 80% 60% at 100% 0%, rgba(255, 255, 255, 0.15), transparent 55%);\n  pointer-events: none;\n}\n\n.commission-modal__close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  color: #fff;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background 0.2s, transform 0.15s;\n}\n\n.commission-modal__close:hover {\n  background: rgba(255, 255, 255, 0.22);\n  transform: scale(1.04);\n}\n\n.commission-modal__eyebrow {\n  margin: 0 0 0.65rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.72);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  position: relative;\n  z-index: 1;\n}\n\n.commission-modal__eyebrow i {\n  font-size: 0.85rem;\n  opacity: 0.9;\n}\n\n.commission-modal__title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  position: relative;\n  z-index: 1;\n}\n\n.commission-modal__id {\n  font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n  font-size: 1.05rem;\n  font-weight: 700;\n  word-break: break-all;\n}\n\n.commission-modal__meta {\n  margin: 0.85rem 0 0;\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.78);\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  position: relative;\n  z-index: 1;\n}\n\n.commission-modal__body--premium {\n  padding: 0;\n  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.commission-modal__section {\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n}\n\n.commission-modal__section:last-of-type {\n  border-bottom: none;\n}\n\n.commission-modal__section--status {\n  background: rgba(255, 255, 255, 0.55);\n}\n\n.commission-modal__section-title {\n  margin: 0 0 1rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.commission-modal__section-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #e0f2fe 0%, #ccfbf1 100%);\n  color: #0f766e;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n}\n\n.commission-modal__pair-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n.commission-modal__pair-card {\n  padding: 1rem 1rem;\n  border-radius: 12px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.commission-modal__pair-label {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 0.35rem;\n}\n\n.commission-modal__pair-value {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.commission-modal__exec-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.85rem;\n}\n\n.commission-modal__stat {\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.commission-modal__stat--span2 {\n  grid-column: span 2;\n}\n\n.commission-modal__stat-label {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 0.4rem;\n}\n\n.commission-modal__stat-value {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.commission-modal__stat-value--num {\n  font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #134e4a;\n}\n\n.commission-modal__status-banner {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.commission-order-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem 1.1rem;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  border: 1px solid #cbd5e1;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  color: #334155;\n}\n\n.commission-order-status i {\n  font-size: 0.95rem;\n}\n\n.commission-order-status--filled,\n.commission-order-status--completed,\n.commission-order-status--success {\n  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);\n  color: #047857;\n  border-color: rgba(16, 185, 129, 0.35);\n}\n\n.commission-order-status--cancelled,\n.commission-order-status--canceled,\n.commission-order-status--rejected {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  color: #b91c1c;\n  border-color: rgba(248, 113, 113, 0.4);\n}\n\n.commission-order-status--pending,\n.commission-order-status--open,\n.commission-order-status--partial {\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n  color: #b45309;\n  border-color: rgba(251, 191, 36, 0.45);\n}\n\n.commission-order-status--unknown {\n  background: #f1f5f9;\n  color: #475569;\n  border-color: #e2e8f0;\n}\n\n.commission-modal__footer {\n  padding: 1rem 1.5rem 1.35rem;\n  background: #fff;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.commission-modal__btn-done {\n  padding: 0.65rem 1.75rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  font-family: inherit;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.35);\n  transition: transform 0.15s, box-shadow 0.2s;\n}\n\n.commission-modal__btn-done:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(15, 118, 110, 0.42);\n}\n\n.commission-modal__btn-done:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 420px) {\n  .commission-modal__pair-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .commission-modal__exec-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .commission-modal__stat--span2 {\n    grid-column: span 1;\n  }\n}\n\n.commission-side {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.commission-side--lg {\n  padding: 0.4rem 0.85rem;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  letter-spacing: 0.04em;\n}\n\n.commission-side--buy {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.commission-side--sell {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.commission-side--neutral {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.commission-status {\n  font-weight: 600;\n  color: #166534;\n}\n\n.commission-table__loading {\n  text-align: center;\n  padding: 2rem 1rem !important;\n  color: var(--text-muted);\n}\n\n.commission-empty--error {\n  margin: 0 1.5rem 0.75rem;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.commission-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border);\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.commission-page-btn {\n  padding: 0.45rem 1rem;\n  font-size: 0.85rem;\n  font-family: inherit;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n}\n\n.commission-page-btn:hover:not(:disabled) {\n  border-color: #0f766e;\n  color: #0f766e;\n}\n\n.commission-page-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
